module.exports = __webpack_public_path__ + "img/1494964599.cf71cc56.jpg";